export const pageTitle = title => {
  'ABC Billings';
};
